module.exports = __webpack_public_path__ + "static/img/7-2.6fe4e36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/7-2.jpg
// module id = 9DrA
// module chunks = 0